const groupedUnits = [
  {
    label: 'Temperature',
    value: 'temperature',
    items: [
      {
        label: '°C',
        value: '°C',
      },
    ],
  },
  {
    label: 'Speed',
    value: 'speed',
    items: [
      {
        label: 'rpm',
        value: 'rpm',
      },
      {
        label: 'Hz',
        value: 'Hz',
      },
      {
        label: 'm/s',
        value: 'm/s',
      },
    ],
  },
  {
    label: 'Area',
    value: 'area',
    items: [
      {
        label: 'm²',
        value: 'm²',
      },
    ],
  },
  {
    label: 'Electricity',
    value: 'electricity',
    items: [
      {
        label: 'V',
        value: 'V',
      },
      {
        label: 'A',
        value: 'A',
      },
    ],
  },
  {
    label: 'Volume',
    value: 'volume',
    items: [
      {
        label: 'L',
        value: 'L',
      },
      {
        label: 'm³',
        value: 'm³',
      },
    ],
  },
  {
    label: 'Flow Rate',
    value: 'flowRate',
    items: [
      {
        label: 'm³/h',
        value: 'm³/h',
      },
      {
        label: 'L/min',
        value: 'L/min',
      },
      {
        label: 'mm/h',
        value: 'mm/h',
      },
    ],
  },
  {
    label: 'Work',
    value: 'work',
    items: [
      {
        label: 'Wh',
        value: 'Wh',
      }
    ],
  },
  {
    label: 'Pressure',
    value: 'pressure',
    items: [
      {
        label: 'bar',
        value: 'bar',
      },
      {
        label: 'Pa',
        value: 'Pa',
      },
      {
        label: 'hPa',
        value: 'hPa',
      },
      {
        label: 'psi',
        value: 'psi',
      },
    ],
  },
  {
    label: 'Power',
    value: 'power',
    items: [
      {
        label: 'W',
        value: 'W',
      },
    ],
  },
  {
    label: 'Percentage',
    value: 'percentage',
    items: [
      {
        label: '%',
        value: '%',
      },
    ],
  },
];

export default groupedUnits;